import GreekLine from "./GreekLine"

const GreekHero = ({ children }) => {
  return (
    <>
      <section className="h-screen w-full">
        {children}
        <GreekLine custCls="relative" />
      </section>
    </>
  )
}

export default GreekHero